import * as React from 'react';
import { View, Text, StyleSheet, Dimensions } from 'react-native';
import { PropsStackModelInfo } from '../types';
import { themePattern } from '../constants/pattern';
import { aminoacidos } from '../assets/aminoacidos';

console.log(aminoacidos(1).info[0]);
const { width, height } = Dimensions.get('window')


export default function ModalDetails({ route, navigation }: PropsStackModelInfo) {


  const { aminoAcid } = route.params;
  const { name, info } = aminoacidos(aminoAcid)
  console.log("INFO", aminoAcid);

  return (
    <View style={styles.container}>
      <View style={styles.text}>
        <Text style={styles.name}>{name}</Text>
        <View style={styles.descrebes}>
          <Text style={styles.descrebePrimary}>{info[0]}</Text>
          <Text style={styles.descrebeSecundary}>{info[1]}</Text>
        </View>

      </View>
    </View>
  );
}

function Styles() {

  //Mobile
  if(themePattern.breakpoint.mobile >= width)
    return StyleSheet.create({
      container: {
        flex: 1,
        justifyContent: 'space-between',
        padding: 15,
        backgroundColor: themePattern.mobile.white,
        borderRadius: 10,
        textAlign: 'center'
      },
      name: {
        textAlign: 'center',
        padding: 15,
        backgroundColor: themePattern.mobile.color1,
        fontSize: themePattern.mobile.title2,
        color: themePattern.mobile.white,
        fontWeight: 'bold',
        borderRadius: 10
      },
      descrebePrimary: {
        color: themePattern.mobile.black,
        fontSize: themePattern.mobile.par2
      },
      descrebeSecundary: {
        backgroundColor: themePattern.mobile.color2,
        color: themePattern.mobile.black,
        fontSize: themePattern.mobile.par2,
        padding: 10,
        paddingTop: 25,
        marginTop: 20,
        paddingBottom: 25,
        borderRadius: 10
      },
      text: {
        flexGrow: 1,
        flex: 1,
        justifyContent: 'space-evenly'
      },
      descrebes:{
        marginTop: 20,
        flexGrow:1,
        justifyContent: 'center'
      } 
    });
  
  //Tablet
  else
  return StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: 'space-between',
      padding: 15,
      backgroundColor: themePattern.tablet.white,
      borderRadius: 10,
      textAlign: 'center'
    },
    name: {
      textAlign: 'center',
      padding: 15,
      backgroundColor: themePattern.tablet.color1,
      fontSize: themePattern.tablet.title2,
      color: themePattern.tablet.white,
      fontWeight: 'bold',
      borderRadius: 10,
      // borderStyle: 'solid',
      // borderColor: themePattern.tablet.black,
      // borderWidth: 2
    },
    descrebePrimary: {
      color: themePattern.tablet.black,
      fontSize: themePattern.tablet.title2
  
    },
    descrebeSecundary: {
      backgroundColor: themePattern.tablet.color2,
      color: themePattern.tablet.black,
      fontSize: themePattern.tablet.title2,
      padding: 10,
      paddingTop: 25,
      marginTop: 20,
      paddingBottom: 25,
      borderRadius: 10
    },
    text: {
      flexGrow: 1,
      flex: 1,
      justifyContent: 'space-evenly'
    },
    descrebes:{
      flex: 1,
      marginTop: 20,
      flexGrow:1,
      justifyContent: 'center'
    } 
  });
}

const styles =  Styles()
